import { AccelFile, ContactCommunication, Entity } from '../../..';
import { observable, action } from 'mobx';
import moment, { type Moment } from 'moment';
import MaxGroup from '../MaxGroup';

export type MaxGroupUserState = 'invited' | 'approved' | 'removed';

export default class MaxGroupUser extends Entity {
    constructor(user?: Partial<MaxGroupUser>) {
        super(user);
        if (user) this.update(user);
    }

    @observable state: MaxGroupUserState;
    @observable createdDate: Moment;
    @observable updatedDate: Moment | null;

    @observable group: MaxGroup;
    @observable communication: ContactCommunication;
    @observable image: AccelFile | null;
    @observable isBot: boolean;

    @action update(g: Partial<MaxGroupUser>, allowUndefined = false) {
        super.update(g, allowUndefined);
    }

    static fromJson(json: any): MaxGroupUser {
        return new MaxGroupUser({
            id: json.id,
            state: json.state,
            softDeleted: json.softDeleted,
            isBot: json.isBot,
            softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : undefined,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
            group: json.group ? MaxGroup.fromJson(json.group) : undefined,
            communication: json.studentCommunication ? ContactCommunication.fromJson(json.studentCommunication) : undefined,
            image: json.image ? AccelFile.fromJson(json.image) : undefined,
        });
    }
}